import { FunctionComponent } from 'react';
import { MaybeLoanID } from 'src/common/types';
import { ServerSideModuleData } from '../../GetServerSideProps/utils/getServerSideModuleData';
import { HeroGraphic } from './HeroGraphic';
import { useHeroGraphicState } from './useHeroGraphicState';

type WiredHeroGraphicProps = {
    loanID: MaybeLoanID;
    serverFetchedData: Pick<ServerSideModuleData, 'HeroGraphic' | 'WelcomeBanner'>;
};
export const WiredHeroGraphic: FunctionComponent<WiredHeroGraphicProps> = ({ serverFetchedData, loanID }) => {
    const { status } = useHeroGraphicState({ loanID, serverFetchedData });

    return <HeroGraphic status={status} />;
};
